import React from 'react';

interface Props {
  layerSource: string;
  setLayerSource: Function;
}

const FeatureServiceLayer: React.FC<Props> = ({ layerSource, setLayerSource }: Props) => (
  <div className="layer-type-form">
    <div className="layer-source clearfix">
      <label htmlFor="layer_source" className="required">Public Feature Service URL</label>
      <div className="input">
        <input
          type="text"
          name="layer[source]"
          id="layer_source"
          placeholder="https://services2.arcgis.com/PYn6bWCjT6bhw1z3/arcgis/rest/services/HHUUD10_Housing_Unit_Change/FeatureServer/1 "
          value={layerSource || ''}
          onChange={(e) => setLayerSource(e.target.value)}
          className="span6"
        />
      </div>
    </div>
  </div>
);

export default FeatureServiceLayer;
